// # new ipo
// # old ipo
export const IPO_BETA_ENABLED =
  (import.meta.env.VITE_IPO_BETA_ENABLED ?? 'true').trim().toLowerCase() === 'true';
